import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance16dzvgcii8pc4 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.k5z_1 = call;
        this.l5z_1 = responseData.u5k_1;
        this.m5z_1 = responseData.p5k_1;
        this.n5z_1 = responseData.s5k_1;
        this.o5z_1 = responseData.q5k_1;
        this.p5z_1 = responseData.v5k_1;
        var tmp = this;
        var tmp_0 = responseData.t5k_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.q5z_1 = tmp0_elvis_lhs == null ? Companion_getInstance().k4k_1 : tmp0_elvis_lhs;
        this.r5z_1 = responseData.r5k_1;
      }
      a5k() {
        return this.k5z_1;
      }
      sv() {
        return this.l5z_1;
      }
      j5k() {
        return this.m5z_1;
      }
      k5k() {
        return this.n5z_1;
      }
      l5k() {
        return this.o5z_1;
      }
      m5k() {
        return this.p5z_1;
      }
      i5k() {
        return this.q5z_1;
      }
      n51() {
        return this.r5z_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
